import React from "react"

const Head = () => {
  return (
    <>
    <section className="head">
        <div className="containerr flexSB">
          <div className="logo">
            <img
              src="/images/Asset7.png"
              alt="Academia Logo"
              className="logo-img"
            />
          </div>

          <div className="social">
            <i className="fab fa-facebook-f icon"></i>
            <i className="fab fa-instagram icon"></i>
            <i className="fab fa-twitter icon"></i>
            <i className="fab fa-youtube icon"></i>
          </div>
        </div>
      </section>
    </>
)
}

export default Head
